function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8 2.79999H13.6C14.0774 2.79999 14.5352 2.98963 14.8728 3.3272C15.2104 3.66476 15.4 4.1226 15.4 4.59999V17.2C15.4 17.6774 15.2104 18.1352 14.8728 18.4728C14.5352 18.8103 14.0774 19 13.6 19H2.8C2.32261 19 1.86477 18.8103 1.52721 18.4728C1.18964 18.1352 1 17.6774 1 17.2V4.59999C1 4.1226 1.18964 3.66476 1.52721 3.3272C1.86477 2.98963 2.32261 2.79999 2.8 2.79999H4.6",
  stroke: "#BFC5D2",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9 1H5.50001C5.00295 1 4.60001 1.40294 4.60001 1.9V3.7C4.60001 4.19706 5.00295 4.6 5.50001 4.6H10.9C11.3971 4.6 11.8 4.19706 11.8 3.7V1.9C11.8 1.40294 11.3971 1 10.9 1Z",
  stroke: "#BFC5D2",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.9b64eb80.svg";
export { ForwardRef as ReactComponent };